import script from "./SettingsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsContainer.vue?vue&type=script&setup=true&lang=js"

import "./SettingsContainer.vue?vue&type=style&index=0&id=10f1b8f4&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f1b8f4"]])

export default __exports__